export default __webpack_public_path__ + "static/media/arrow-pointer.7f0cd3fe.svg";